import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './post_natal.scss';

export default function PostNatal(props) {
  const [formData, setFormData] = useState({
    investigations: '• CBC after 4 weeks\n• TSH / Blood sugar (FBS, PPBS) if on Thyronorm or Glycomet',
    contraceptiveAdvice: 'Condom / Copper IUCD / Centchroman — as per patient preference',
    vaccination: 'Cervical Cancer Vaccine: Inj. Cervavac — advice given'
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  const [showTables, setShowTables] = useState({
    medication: true
  });

  const medicationHeaders = [
    {key: 'drug', label: 'Drug (Brand Name + Generic Name)'},
    {key: 'indication', label: 'Indication / Instructions'},
    {key: 'dose', label: 'Dose'},
    {key: 'frequency', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'duration', label: 'Duration'}
  ];

  const [medicationRows, setMedicationRows] = useState([
    {
      drug: 'T. Globac XT / Furnext (Ferrous ascorbate + Folic acid + Zinc)',
      indication: 'Iron supplement — Do not take with calcium. Take with food rich in Vitamin C.',
      dose: '1 tab',
      frequency: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      drug: 'T. Tricium XT (Calcium carbonate + Vitamin D₃)',
      indication: 'Calcium supplement',
      dose: '1 tab',
      frequency: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      drug: 'C. Folvista (Folic acid 5 mg)',
      indication: 'Folic acid supplement',
      dose: '1 cap',
      frequency: '0-1-0',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      drug: 'T. Thyronorm (Levothyroxine sodium)',
      indication: 'Continue as per endocrinologist advice',
      dose: '1 tab',
      frequency: '1-0-0',
      route: 'Oral',
      timing: 'Early morning empty stomach',
      duration: 'As advised'
    },
    {
      drug: 'T. Glycomet (Metformin 500 mg / 1000 mg)',
      indication: 'Continue if diabetic / GDM',
      dose: '1 tab',
      frequency: 'OD',
      route: 'Oral',
      timing: 'After food',
      duration: 'As advised'
    },
    {
      drug: 'Viva Mom / Mother Horlicks / Protinex Mama (Protein and micronutrient supplement)',
      indication: 'Optional nutritional drink with milk',
      dose: '2 tsp',
      frequency: '0-0-2 tsp',
      route: 'Oral',
      timing: 'After food',
      duration: '30 days'
    },
    {
      drug: 'Galact / Lactonic Granules (Fenugreek + Shatavari + Herbal galactagogues)',
      indication: 'To enhance breast milk',
      dose: '2 tsp with milk',
      frequency: '—',
      route: 'Oral',
      timing: 'Between meals',
      duration: '30 days'
    },
    {
      drug: 'C. Lactare / Xenolact (Shatavari extract + Herbal galactagogues)',
      indication: 'Lactation support',
      dose: '2 caps',
      frequency: '2-2-2',
      route: 'Oral',
      timing: '—',
      duration: '30 days'
    },
    {
      drug: 'T. Vit C 500 mg (Ascorbic acid)',
      indication: 'Antioxidant support',
      dose: '1 tab',
      frequency: '1-0-1',
      route: 'Oral',
      timing: '—',
      duration: '30 days'
    },
    {
      drug: 'T. Neuroplex / Becosules (Multivitamin + B-complex)',
      indication: 'General postnatal supplement',
      dose: '1 tab',
      frequency: 'OD',
      route: 'Oral',
      timing: '—',
      duration: '30 days'
    },
    {
      drug: 'Hip Belt / Abdominal Support Belt',
      indication: 'Use if needed; avoid while sleeping, feeding, or eating',
      dose: '—',
      frequency: '—',
      route: '—',
      timing: '—',
      duration: 'As advised'
    }
  ]);

  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '30px',
        // lineHeight: "20px",
        display: 'flex',
        alignItems: 'center',
        height: '20px'
      }}>
      ●
    </span>
  );
  const renderIndentation = () => (
    <span
      style={{
        visibility: 'hidden',
        fontSize: '30px',
        lineHeight: '20px'
      }}>
      ●
    </span>
  );

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  };

  const handleNill = (id, setShowTables) => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const handlesubmit = () => {
    props.loaderchange('true');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('prescriptionReportWrap').innerHTML;
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Post Natal'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='PostNatal'>
      <div className='PostNatal'>
        <div className='patient-info-wrapper' id='patientInfo1'>
          <div className='header-image-container'>
            <img className='header_image' src={headerimage} alt='header'></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>POSTNATAL PRESCRIPTION</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Mode of Delivery'
                name='modeOfDelivery'
                value={formData.modeOfDelivery}
                options={[
                  {label: 'Vaginal Delivery', value: 'Vaginal Delivery'},
                  {label: 'Emergency LSCS', value: 'Emergency LSCS'},
                  {label: 'Elective LSCS', value: 'Elective LSCS'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Sterilization'
                name='sterilization'
                value={formData.sterilization}
                options={[
                  {label: 'Yes', value: 'Yes'},
                  {label: 'No', value: 'No'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Wound'
                name='wound'
                value={formData.wound}
                options={[
                  {label: 'Healthy', value: 'Healthy'},
                  {label: 'Induration', value: 'Induration'},
                  {label: 'Discharge', value: 'Discharge'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <h3 className='mt-3'>O/E</h3>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP :' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='WT :' name='wt' value={formData.wt} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
          </div>
        </div>
        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='Medications'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='investigations'>
          <h3>Investigations</h3>
          <textarea
            className='Textarea'
            name='investigations'
            onChange={handleChange}
            rows='3'
            cols='120'
            defaultValue={'• CBC after 4 weeks\n• TSH / Blood sugar (FBS, PPBS) if on Thyronorm or Glycomet'}
          />
        </div>
        <div className='contraceptive-advice'>
          <h3>Contraceptive Advice</h3>
          <textarea className='Textarea' name='contraceptiveAdvice' onChange={handleChange} rows='3' cols='120' defaultValue={'Condom / Copper IUCD / Centchroman — as per patient preference'} />
        </div>
        <div className='vaccination'>
          <h3>Vaccination</h3>
          <textarea className='Textarea' name='vaccination' onChange={handleChange} rows='3' cols='120' defaultValue={'Cervical Cancer Vaccine: Inj. Cervavac — advice given'} />
        </div>
        <div className='bulletin'>
          <h4>POSTNATAL CARE INSTRUCTIONS</h4>
          <ul className='px-3'>
            <li>Hope you&rsquo;re recovering well</li>
            <li>Mild wound pain or soreness is common for a few weeks. Sit in warm water (hip bath) for 5 minutes daily.</li>
            <li>For LSCS wound: keep open to air; may bathe with soap & water.</li>
            <li>Lochia (post-delivery discharge) continues 4–6 weeks; amount and color vary.</li>
            <li>If you had high BP in pregnancy, check BP daily; report if &gt;160/100 mmHg.</li>
            <li>Lactation consultation advised if poor milk output, pain, or engorgement.</li>
            <li>Maintain hydration, rest, and a protein-rich diet.</li>
          </ul>
        </div>
        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='prescriptionReport'>
        <div id='prescriptionReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginTop: '5px', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>POSTNATAL PRESCRIPTION </h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Mode of Delivery :', formData.modeOfDelivery)}
            {renderReportfield('Sterilization :', formData.sterilization)}
            {renderReportfield('Wound :', formData.wound)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('BP :', formData.bp)}mmHg
            {renderReportfield('WT :', formData.wt)}Kg
          </div>
          {showTables.medication &&
            renderDynamicTable(
              'Medications',
              ['Drug (Brand Name + Generic Name)', 'Indication / Instructions', 'Dose', 'Frequency', 'Route', 'Timing', 'Duration'],
              ['drug', 'indication', 'dose', 'frequency', 'route', 'timing', 'duration'],
              medicationRows
            )}

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Investigations:', formData.investigations)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Contraceptive Advice:', formData.contraceptiveAdvice)}</div>
          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('Vaccination:', formData.vaccination)}</div>
          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>POSTNATAL CARE INSTRUCTIONS</h6>
          </div>
          {[
            'Hope you’re recovering well',
            'Mild wound pain or soreness is common for a few weeks. Sit in warm water (hip bath) for 5 minutes daily.',
            'For LSCS wound: keep open to air; may bathe with soap & water.',
            'Lochia (post-delivery discharge) continues 4–6 weeks; amount and color vary.',
            'If you had high BP in pregnancy, check BP daily; report if >160/100 mmHg.',
            'Lactation consultation advised if poor milk output, pain, or engorgement.',
            'Maintain hydration, rest, and a protein-rich diet.'
          ].map((ele, ind) => {
            return (
              <div style={{display: 'flex', marginBottom: '5px'}}>
                {renderIndentation()}
                {renderDiscPoint()}
                {renderReportfield(ele, '', {styleSec: {width: '100%'}})}
              </div>
            );
          })}

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}

